document.addEventListener('DOMContentLoaded', function() {
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function(event) {
    var allBoldInputs = document.querySelectorAll('.bold_option_element');
    allBoldInputs.forEach(function(boldInput) {
      boldInput.addEventListener('click', handleClick);
    })
  });
});

function handleClick() {
  if (event.target.tagName === 'INPUT') {
    console.log('an input has been clicked', this);
    var localInputs = this.querySelectorAll('input');
    console.log('All local inputs are', localInputs);
    localInputs.forEach(function(input) {
      if (input.checked === true) {
        input.parentElement.parentElement.style.borderColor = '#000';
      } else {
        input.parentElement.parentElement.style.borderColor = '#d0d0d0';
      }
    })
  }
}

document.addEventListener('DOMContentLoaded', function() {
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function(event) {  
    document.addEventListener("mousemove", (e) => {
    const button = e.target.closest(".bold_option_value");
    if (button) {
        const buttonRect = button.getBoundingClientRect();

        const mouseX = e.clientX;
        const mouseY = e.clientY;

        const buttonX = buttonRect.left + buttonRect.width / 2;
        const buttonY = buttonRect.top + buttonRect.height / 2;

        const deltaX = mouseX - buttonX;
        const deltaY = mouseY - buttonY;

        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

        const magneticStrength = 100;

        if (distance < magneticStrength) {
            const angle = Math.atan2(deltaY, deltaX);
            const magnetism = 1 - distance / magneticStrength;

            const offsetX = Math.cos(angle) * magnetism * 9;
            const offsetY = Math.sin(angle) * magnetism * 9;

            button.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
        } else {
            button.style.transform = "translate(0, 0)";
          }
        }
    });
  });
});
